import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import { searchPosItems as searchPosItemsRoutine } from './routines';

export const searchPosItems = ({ payload: qs }) =>
  sagaRoutineRequest(searchPosItemsRoutine, {
    request: () => call(Api.searchPosItems, { qs })
  });
